import React, { useCallback } from "react";
import { Link } from "react-router-dom";

import equalBigIcon from "../../img/logo-equal.png";
import equityBigIcon from "../../img/logo-equity.png";

import { FTM,switchNetwork, useChainId } from "../../Helpers";

import { useWeb3React } from "@web3-react/core";

import APRLabel from "../APRLabel/APRLabel";

export default function TokenCard() {
  const { chainId } = useChainId();
  const { active } = useWeb3React();

  const changeNetwork = useCallback(
    (network) => {
      if (network === chainId) {
        return;
      }
      if (!active) {
        setTimeout(() => {
          return switchNetwork(network, active);
        }, 500);
      } else {
        return switchNetwork(network, active);
      }
    },
    [chainId, active]
  );

  return (
    <div className="Home-token-card-options ">
      <div className="Home-token-card-option borderradius">
        <div className="Home-token-card-option-icon">
          <img src={equalBigIcon} alt="equalBigIcon" style={{width: '40px', height: '40px'}}/> veEQUAL
        </div>
        <div className="Home-token-card-option-info">
          <div className="Home-token-card-option-title">
            <p>Our staple product veEQUAL, earn 100% of trading fees across both of our platforms.</p>
            {/* Acquires 30% of the earnings the platform generates. */}
          </div>
          {/* <div className="Home-token-card-option-apr">
            Fantom APR: <APRLabel chainId={FTM} label="equalAprTotal" />
          </div> */}
          <div className="Home-token-card-option-action">
            <div className="buy">
              <a href="https://equalizer.exchange/swap" className="default-btnhome">
              {/* <Link to="/buy_equal" className="default-btnhome" onClick={() => changeNetwork(FTM)}> */}
              {"Acquire veEQUAL NFT"}
              </a>
            </div>
            <a
              href="https://docs.equalizer.exchange/"
              target="_blank"
              rel="noreferrer"
              className="default-btnhome read-more"
            >
              READ MORE
            </a>
          </div>
        </div>
      </div>
      <div className="Home-token-card-option borderradius">
        <div className="Home-token-card-option-icon ">
          <img src={equityBigIcon} alt="equityBigIcon" style={{width: '40px', height: '40px'}} /> EQUITY
        </div>
        <div className="Home-token-card-option-info">
          <div className="Home-token-card-option-title">
          <p>Experience the fluidity of Equity's market through our Market-Maker Shares, known as EQUITY</p>
          {/* The platform's liquidity token, EQUITY, receives 60% of the fees collected. */}
          </div>
          {/* <div className="Home-token-card-option-apr">
            Fantom APR: <APRLabel chainId={FTM} label="equityAprTotal" key="FTM" />
          </div> */}
          <div className="Home-token-card-option-action">
            <div className="buy">
              <Link to="/manage" className="default-btnhome" onClick={() => changeNetwork(FTM)}>
                Mint EQUITY
              </Link>
              {/*
              <Link to="/buy_equity#redeem" className="default-btnhome" onClick={() => changeNetwork(FTM)}>
                Redeem
              </Link>
              */}
            </div>
            <a
              href="https://docs.equalizer.exchange"
              target="_blank"
              rel="noreferrer"
              className="default-btnhome read-more"
            >
              READ MORE
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
